module.exports = __webpack_public_path__ + "static/media/maxParties_150_200.909877f2.png";